module.exports = __webpack_public_path__ + "img/loan.5707d715.webp";